import Types from "./Types";
/************************************************
Get user details
*************************************************/

const getUser = () => ({
  type: Types.GET_USER
});

const getUserSuccess = user => ({
  type: Types.GET_USER_SUCCESS,
  user
});

const getUserFailure = () => ({
  type: Types.GET_USER_FAILURE
});

/************************************************
Get seller details
*************************************************/

const getSeller = () => ({
  type: Types.GET_SELLER
});

const getSellerSuccess = (seller, isNoonUser, partnerCountries, partnerMenu) => ({
  type: Types.GET_SELLER_SUCCESS,
  seller,
  isNoonUser,
  partnerCountries,
  partnerMenu
});

const getSellerFailure = () => ({
  type: Types.GET_SELLER_FAILURE
});

/************************************************
Logout
*************************************************/
const logout = () => ({
  type: Types.LOGOUT
});

const logoutSuccess = () => ({
  type: Types.LOGOUT_SUCCESS
});

const logoutFailure = () => ({
  type: Types.LOGOUT_FAILURE
});

/************************************************
GET NOTIFICATION PREFERENCE
*************************************************/
const getNotificationPreference = () => ({
  type: Types.GET_NOTIFICATION_PREFERENCE
});

const getNotificationPreferenceSuccess = (preference) => ({
  type: Types.GET_NOTIFICATION_PREFERENCE_SUCCESS,
  preference
});

const getNotificationPreferenceFailure = () => ({
  type: Types.GET_NOTIFICATION_PREFERENCE_FAILURE
});

/************************************************
POST NOTIFICATION PREFERENCE
*************************************************/
const postPreference = (pref: Object) => ({
  type: Types.POST_PREFERENCE,
  pref
});

const postPreferenceSuccess = (pref: Object) => ({
  type: Types.POST_PREFERENCE_SUCCESS,
  pref
});

const postPreferenceFailure = (error: Object) => ({
  type: Types.POST_PREFERENCE_FAILURE,
  error
});

/************************************************
    Get seller details
*************************************************/

const acceptTerms = () => ({
  type: Types.ACCEPT_TERMS
});

const acceptTermsSuccess = seller => ({
  type: Types.ACCEPT_TERMS_SUCCESS,
  seller
});

const acceptTermsFailure = () => ({
  type: Types.ACCEPT_TERMS_FAILURE
});

/************************************************
Get user actions
*************************************************/

const getTnC = country => ({
  type: Types.GET_TNC,
  country
});

const getTnCSuccess = tnc => ({
  type: Types.GET_TNC_SUCCESS,
  tnc
});

const getTnCFailure = () => ({
  type: Types.GET_TNC_FAILURE
});

/************************************************
Get all warehouses
*************************************************/

const getWareHouses = query => ({
  type: Types.GET_WAREHOUSES,
  query
});

const getWareHousesSuccess = warehouses => ({
  type: Types.GET_WAREHOUSES_SUCCESS,
  warehouses
});

const getWareHousesFailure = () => ({
  type: Types.GET_WAREHOUSES_FAILURE
});

/************************************************
Get vat
*************************************************/

const getVatInfo = () => ({
  type: Types.GET_VAT_INFO
});

const getVatInfoSuccess = vat => ({
  type: Types.GET_VAT_INFO_SUCCESS,
  vat
});

const getVatInfoFailure = () => ({
  type: Types.GET_VAT_INFO_FAILURE
});

/************************************************
Get all users list
*************************************************/

const getUsersList = () => ({
  type: Types.GET_USERS_LIST
});

const getUsersListSuccess = users => ({
  type: Types.GET_USERS_LIST_SUCCESS,
  users
});

const getUsersListFailure = () => ({
  type: Types.GET_USERS_LIST_FAILURE
});

/************************************************
Get all users list
*************************************************/

const getOfferCount = () => ({
  type: Types.GET_OFFER_COUNT
});

const getOfferCountSuccess = offerCount => ({
  type: Types.GET_OFFER_COUNT_SUCCESS,
  offerCount
});

const getOfferCountFailure = () => ({
  type: Types.GET_OFFER_COUNT_FAILURE
});

/*****
SYNC INVENTORY
*************************************************/

const syncInventory = () => ({
  type: Types.SYNC_INVENTORY
});

const syncInventorySuccess = () => ({
  type: Types.SYNC_INVENTORY_SUCCESS
});

const syncInventoryFailure = () => ({
  type: Types.SYNC_INVENTORY_FAILURE
});
/*************************************************

Get notification details
*************************************************/

const getNotification = (query, isList) => ({
  type: Types.GET_NOTIFICATION,
  query,
  isList
});

const getNotificationSuccess = notification => ({
  type: Types.GET_NOTIFICATION_SUCCESS,
  notification
});

const getNotificationFailure = () => ({
  type: Types.GET_NOTIFICATION_FAILURE
});

/************************************************
Read notification
*************************************************/

const readNotification = notObj => {
  return {
    type: Types.READ_NOTIFICATION,
    notObj
  };
};

const readNotificationSuccess = () => {
  return {
    type: Types.READ_NOTIFICATION_SUCCESS
  };
};

const readNotificationFailure = () => ({
  type: Types.READ_NOTIFICATION_FAILURE
});
/************************************************
FBN Settings
*************************************************/

const getFbnSettings = () => {
  return {
    type: Types.GET_FBN_SETTINGS
  };
};

const getFbnSettingsSuccess = (fbnSetting) => {
  return {
    type: Types.GET_FBN_SETTINGS_SUCCESS,
    fbnSetting
  };
};

const getFbnSettingsFailure = () => ({
  type: Types.GET_FBN_SETTINGS_FAILURE
});

/************************************************
POST NOTIFICATION PREFERENCE
*************************************************/
const changeFbnSettings = (setting: Object) => ({
  type: Types.CHANGE_FBN_SETTINGS,
  setting
});

const changeFbnSettingsSuccess = (fbnSetting: Object) => ({
  type: Types.CHANGE_FBN_SETTINGS_SUCCESS,
  fbnSetting
});

const changeFbnSettingsFailure = (error: Object) => ({
  type: Types.CHANGE_FBN_SETTINGS_FAILURE,
  error
});


export {
  getUser,
  getUserSuccess,
  getUserFailure,
  getSeller,
  getSellerSuccess,
  getSellerFailure,
  getTnC,
  getTnCSuccess,
  getTnCFailure,
  acceptTerms,
  acceptTermsSuccess,
  acceptTermsFailure,
  logout,
  logoutSuccess,
  logoutFailure,
  getWareHouses,
  getWareHousesSuccess,
  getWareHousesFailure,
  getUsersList,
  getUsersListSuccess,
  getUsersListFailure,
  getVatInfo,
  getVatInfoSuccess,
  getVatInfoFailure,
  getOfferCount,
  getOfferCountSuccess,
  getOfferCountFailure,
  syncInventory,
  syncInventorySuccess,
  syncInventoryFailure,
  getNotification,
  getNotificationSuccess,
  getNotificationFailure,
  readNotification,
  readNotificationSuccess,
  readNotificationFailure,
  getNotificationPreference,
  getNotificationPreferenceSuccess,
  getNotificationPreferenceFailure,
  postPreference,
  postPreferenceSuccess,
  postPreferenceFailure,
  getFbnSettings,
  getFbnSettingsSuccess,
  getFbnSettingsFailure,
  changeFbnSettings,
  changeFbnSettingsSuccess,
  changeFbnSettingsFailure
};


// WEBPACK FOOTER //
// ./src/actions/UserActions.js